var map = {
	"./arg.svg": 425,
	"./aus.svg": 7148,
	"./aut.svg": 3891,
	"./bel.svg": 9360,
	"./can.svg": 4547,
	"./cze.svg": 5689,
	"./den.svg": 4760,
	"./dnk.svg": 6928,
	"./esp.svg": 7341,
	"./est.svg": 3569,
	"./fra.svg": 3956,
	"./gbr.svg": 3642,
	"./ger.svg": 7655,
	"./hun.svg": 3076,
	"./isr.svg": 5771,
	"./ita.svg": 3013,
	"./ned.svg": 9020,
	"./pol.svg": 1936,
	"./por.svg": 5030,
	"./rer.svg": 4294,
	"./rsa.svg": 6207,
	"./rus.svg": 1703,
	"./srb.svg": 8606,
	"./sui.svg": 3304,
	"./swe.svg": 1190,
	"./ukr.svg": 7543,
	"./usa.svg": 3692,
	"./zam.svg": 9165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7505;